/* SALITE – Countdown für den nächsten Drop
   Markup: [data-sal-countdown][data-target="2026-10-16T18:00:00+02:00"]
           enthält [data-unit="days|hours|minutes|seconds"]
           optional im umgebenden [data-sal-drop]: [data-sal-heading][data-live-text]
   Ohne gültiges Datum bleiben die Platzhalter-Striche stehen. */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(root) {
    if (!root || root.__salReady) return;
    root.__salReady = true;

    var raw = (root.getAttribute('data-target') || '').replace(/^(\d{4}-\d{2}-\d{2})\s+(\d)/, '$1T$2');
    var target = Date.parse(raw);
    if (isNaN(target)) return;

    var scope = root.closest('[data-sal-drop]') || document;
    var heading = scope.querySelector('[data-sal-heading]');
    var liveText = heading ? heading.getAttribute('data-live-text') : '';
    var out = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };
    if (!out.days || !out.hours || !out.minutes || !out.seconds) return;

    var timer;

    function render() {
      if (!root.isConnected) {
        clearInterval(timer);
        return;
      }

      var diff = target - Date.now();

      if (diff <= 0) {
        out.days.textContent = out.hours.textContent = out.minutes.textContent = out.seconds.textContent = '00';
        if (heading && liveText) heading.textContent = liveText;
        clearInterval(timer);
        return;
      }

      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      s -= d * 86400;
      var h = Math.floor(s / 3600);
      s -= h * 3600;
      var m = Math.floor(s / 60);
      s -= m * 60;

      out.days.textContent = pad(d);
      out.hours.textContent = pad(h);
      out.minutes.textContent = pad(m);
      out.seconds.textContent = pad(s);
    }

    render();
    timer = setInterval(render, 1000);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-sal-countdown]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  /* Shopify-Theme-Editor: Abschnitt wurde neu geladen */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
